@use "../../styles/breakpoint.module.scss" as *;

.inner {
    composes: safeGridContainer from "../../styles/composable/layout.module.css";
}

.search {
    grid-column: 3 / span 8;
    padding-block: var(--spacer-40) var(--spacer-24);
    font: var(--font-p-16);

    @media ($below-mobile) {
        grid-column: 1 / -1;
    }
}

.heading {
    font: var(--font-h-40-forma);
    text-align: center;
}

.inner .input {
    margin-top: var(--spacer-16);

    input {
        width: 100%;
        padding-left: 0;
        font: var(--font-p-24);
    }
}

.popover {
    width: var(--trigger-width);

    [role="option"] {
        padding: 0;
    }
}

.item {
    padding: var(--spacer-8);
    border-bottom: 1px solid var(--gray-300);
    cursor: pointer;
}

.sku {
    display: block;
    font: var(--font-p-12);
}

.title {
    font: var(--font-p-18);
}

.help {
    margin-top: var(--spacer-16);
}

.helpTrigger {
    display: inline-block;
    margin-left: var(--spacer-4);
    font: var(--font-text-link-14);
    text-decoration: underline;
}

.inner .cards {
    grid-column: 1 / -1;
    margin: 0;
}

.product {
    grid-column: 1 / -1;
}

.downloads {
    grid-column: 3 / span 8;
    padding-block: var(--spacer-40);

    @media ($below-mobile) {
        grid-column: 1 / -1;
    }
}

.helpPanel {
    grid-column: 2 / span 10;

    @media ($below-mobile) {
        grid-column: 1 / -1;
    }
}
